import {
  InlineDatumReactComponentProps,
  useAnalytics,
} from '@stripe-internal/inline-data';
import {view, Button, Icon} from '@sail/ui';
import {external} from '@sail/icons/react/Icon';
import {FormattedMessage, defineMessages} from 'react-intl';
import {widgetLinkAction} from '@stripe-internal/conversations-ui';

const messages = defineMessages({
  problemsNotice: {
    id: 'risk.review_form.sla_message',
    description: 'SLA message',
    defaultMessage:
      'Got it. Please submit the form below to trigger a review. {slaMessage}',
  },
  reviewFormCTA: {
    id: 'risk.review_form.cta',
    description: 'Review form CTA',
    defaultMessage: 'Complete form',
  },
  genericInterventionWithOpenForm: {
    id: 'risk.review_form.generic_intervention_with_open_form',
    description: 'Generic intervention with open dashboard form message',
    defaultMessage:
      'It looks like we need some information about your business. Please fill out to the form linked below. {slaMessage}',
  },
  genericInterventionWithFormInReview: {
    id: 'risk.review_form.generic_intervention_with_form_in_review',
    description: 'Generic intervention with form in review message',
    defaultMessage:
      'It looks like you have already provided the required information. {slaMessage}',
  },
});

export type ValueProps = {
  sla_message?: string;
  dashboard_form_url?: string;
  /**
   * Matches the message_type prop in
   * [ReviewForm](https://stripe.sourcegraphcloud.com/stripe-internal/pay-server/-/blob/lib/support/inline_data/risk/review_form.rb)
   */
  message_type?: 'in_progress' | 'additional_information_shown' | 'generic';
};

export const RiskReviewForm = (props: InlineDatumReactComponentProps) => {
  const {datum} = props;
  const analytics = useAnalytics();

  const {
    sla_message: slaMessage,
    dashboard_form_url: dashboardFormUrl,
    message_type: messageType,
  } = datum.value as ValueProps;

  let message;
  switch (messageType) {
    case 'in_progress':
      message = messages.genericInterventionWithFormInReview;
      break;
    case 'generic':
      message = messages.genericInterventionWithOpenForm;
      break;
    default:
      message = messages.problemsNotice;
  }

  return (
    <view.div css={{stack: 'y', gap: 'large'}}>
      <view.div css={{stack: 'y', gap: 'large'}}>
        <FormattedMessage
          {...message}
          values={{
            slaMessage,
          }}
        />
      </view.div>
      {dashboardFormUrl && messageType !== 'in_progress' ? (
        <view.div css={{stack: 'y', gap: 'large'}}>
          <Button
            data-testid="review-form-cta"
            type="primary"
            css={{width: 'fill'}}
            uses={[widgetLinkAction()]}
            href={dashboardFormUrl}
            onPress={() => {
              analytics.action('uh_review_form_button', {
                dashboardFormUrl,
              });
            }}
          >
            <FormattedMessage {...messages.reviewFormCTA} />
            <Icon icon={external} />
          </Button>
        </view.div>
      ) : null}
    </view.div>
  );
};
